<template lang="pug">
.new-simulation-form
  .card-box
    .row
      .col-md-9.col-sm-12
        h3.text-dark.site-title.m-t-m-b-30
          span 無料でページをまるごとWebP変換
          small.m-l-5.d-none.d-sm-inline 30秒でレポート表示・一括ダウンロード
        .m-t-30
        .form-group
          label
            | チェックするページのURL
            = ' '
            span.badge.badge-danger 必須
          input.form-control(type="url" name="url" v-bind:class="{'is-invalid': errors.has('url')}" v-validate="'required|url'" v-model.lazy="url" placeholder="https://www.ideamans.com/" lazy)
          .invalid-feedback(v-if="errors.has('url')") {{ errors.first('url') }}

        .form-group
          .form-check.form-check-inline
            label
              input.form-check-input(type="radio" value="sp" v-model="device")
              i.mdi.mdi-cellphone-iphone
              = ' '
              | スマートフォンとしてアクセス
            label.m-l-10
              input.form-check-input(type="radio" value="pc" v-model="device")
              i.mdi.mdi-laptop
              = ' '
              | PCブラウザとしてアクセス

        .form-group
          label
            | 通知先メールアドレス
            = ' '
            span.badge.badge-danger 必須
          input.form-control(type="email" name="email" v-bind:class="{'is-invalid': errors.has('email')}" v-validate="'required|email'" v-model.lazy="email" placeholder="your@example.com" lazy)
          .invalid-feedback(v-if="errors.has('email')") {{ errors.first('email') }}
          small.text-hint
            | シミュレーションには時間がかかる場合があります。準備ができたらお知らせします。

        .m-t-30
          input(type="hidden" v-model="ip")
          button.btn.btn-lg.btn-primary(v-on:click="start")
            | ページまるごとWebP変換
            i.mdi.mdi-arrow-right
      .col-md-3.d-none.d-md-block.text-center
        router-link(to="/reports/d065827f-40dc-4912-b38f-dd40ae52add0")
          span.m-b-10.badge.badge-dark
            | レポートの例
            i.mdi.mdi-arrow-right.m-l-5
          img.img-responsive.img-thumbnail(src="example.png")

</template>

<script>
import Lib from '@/lib'
import Axios from 'axios'

export default {
  data() {
    return {
      url: '',
      ip: '',
      device: 'sp',
      email: '',
    }
  },
  methods: {
    start: async function() {
      const app = new Lib.App()

      const validation = await this.$validator.validateAll()
      if (!validation) {
        return
      }

      const task = await app.sendNewSimulationTask({
        url: this.url,
        ip: this.ip,
        device: this.device,
        email: this.email,
      });
      
      this.$router.push({ name: 'report', params: { id: task.id } });
    }
  },
  created() {
    this.url = window.localStorage.getItem('url') || '';
    this.email = window.localStorage.getItem('email') || '';
    this.device = window.localStorage.getItem('device') || 'sp';

    Axios.get('https://mautic-gateway.ideamans.com/me')
      .catch(ex => console.error(ex))
      .then(res => {
        this.ip = res.data.ip
      });
  },
  watch: {
    url() {
      window.localStorage.setItem('url', this.url);
    },
    email() {
      window.localStorage.setItem('email', this.email);
    },
    device() {
      window.localStorage.setItem('device', this.device);
    },
  }
}
</script>